// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"77ea9c1e","157":"45db0a48","277":"09f3d8da","360":"41b88a54","492":"8adf5968","537":"162b20f1","953":"8ec0eea3"}[chunkId] + ".chunk.css";
};